import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/maintenance';

export class MaintenanceService extends RestServiceConnection {

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES LISTA LOS MANTENIMIENTOS
     * @EN LISTS THE MAINTENANCES
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listMaintenances = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN MANTENIMIENTO POR ID
     * @EN GETS A MAINTENANCE BY ID
     * 
     * @param maintenanceId
     */
    //-------------------------------------------------------------------------------------------------------------
    getMaintenanceById = async (maintenanceId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: {
                id: maintenanceId
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN NUEVO MANTENIMIENTO
     * @EN CREATES A NEW MAINTENANCE
     * 
     * @param maintenance
     */
    //-------------------------------------------------------------------------------------------------------------
    createMaintenance = async (maintenance: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: maintenance,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UN MANTENIMIENTO
     * @EN UPDATES A MAINTENANCE
     * 
     * @param maintenance
     */
    //-------------------------------------------------------------------------------------------------------------
    editMaintenance = async (maintenance: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: maintenance,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN MANTENIMIENTO
     * @EN DELETES A MAINTENANCE
     * 
     * @param maintenanceId
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteMaintenance = async (maintenanceId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: {
                id: maintenanceId
            }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA MÚLTIPLES MANTENIMIENTOS
     * @EN DELETES MULTIPLE MAINTENANCES
     * 
     * @param maintenanceIds
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteMultiMaintenances = async (maintenanceIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: {
                ids: maintenanceIds
            }
        }, true);
        return this;
    }

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA TODOS LOS MANTENIMIENTOS
     * @EN DELETES ALL MAINTENANCES
     * 
     * @param companyId
     */
    //-------------------------------------------------------------------------------------------------------------
    deleteAllMaintenances = async (companyId: string|null) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-all',
            data: {
                company: companyId
            },
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE ESTADÍSTICAS DE MANTENIMIENTOS
     * @EN GETS MAINTENANCE STATISTICS
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    getMaintenanceStatistics = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/statistics',
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE MANTENIMIENTOS DE UN VEHÍCULO CON ESTADÍSTICAS
     * @EN GETS VEHICLE MAINTENANCES WITH STATISTICS
     * 
     * @param vehicleId
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    getVehicleMaintenancesWithStats = async (vehicleId: string, filters?: any) => {
        const maintenanceFilters = {
            vehicleId,
            ...filters
        };
        
        // Obtener tanto la lista como las estadísticas en paralelo
        const [maintenancesResponse, statisticsResponse] = await Promise.all([
            this.listMaintenances(maintenanceFilters),
            this.getMaintenanceStatistics(maintenanceFilters)
        ]);
        
        const maintenancesData = maintenancesResponse.getResponseData();
        const statisticsData = statisticsResponse.getResponseData();
        
        // Mantener la respuesta de mantenimientos como base
        this.response = maintenancesResponse.response;
        
        // Agregar las estadísticas a los datos existentes
        if (this.response && this.response.data) {
            this.response.data.statistics = statisticsData;
        }
        
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA REPOSTAJES DESDE UN EXCEL
     * @EN IMPORTS REFUELS FROM AN EXCEL FILE
     */
    // -------------------------------------------------------------------------------------------------------------
    importExcel = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: ENDPOINT + "/import",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}